import type { Error } from '../types';
import { DNI_CONTROL_LETTERS, DNI_REGEX } from '../utils/regex';
import { validateEsTax } from '../utils/validateEsTax';

export const validateDNI =
  (message?: Error['message']) =>
  (value: string): Error => {
    if (!value || value.length === 0 || !DNI_REGEX.test(value)) {
      return {
        valid: false,
        message
      };
    }

    const isDniValid = validateEsTax(value, DNI_CONTROL_LETTERS);
    if (!isDniValid) {
      return {
        valid: false,
        message
      };
    }

    return { valid: true };
  };
